import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SignupHeaderStore {

}

export enum SignupHeaderStoreKeys {

}
